import '!ng-cache-loader!./ContactBody.html';
import './Contact.scss';
import { ConfirmationModal } from 'modules/ui';
import { v4 as uuid } from 'uuid';
const contactCardIdPrefix = 'contact-card-';
const AI_AGENT = 'AiAgent';
var ContactSize;
(function (ContactSize) {
    ContactSize["Small"] = "small";
    ContactSize["Normal"] = "medium";
})(ContactSize || (ContactSize = {}));
export class ContactController {
    static $inject = ['ModalService', 'ngToast', '$translate', 'AuthenticationService', 'ApplicationTeamService', 'BlipToastService', 'APPLICATION_DEFAULT_IMAGE', '$state'];
    constructor(ModalService, ngToast, $translate, AuthenticationService, ApplicationTeamService, BlipToastService, APPLICATION_DEFAULT_IMAGE, $state) {
        'ngInject';
        this.ModalService = ModalService;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.AuthenticationService = AuthenticationService;
        this.ApplicationTeamService = ApplicationTeamService;
        this.BlipToastService = BlipToastService;
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.$state = $state;
        this.contactCardId = `${contactCardIdPrefix}${uuid()}`;
    }
    $onInit() {
        if (this.size == ContactSize.Normal) {
            this.avatarSize = 'standard';
        }
        else {
            this.avatarSize = 'small';
        }
    }
    $onChanges(changes) {
        const { checkable, size } = changes;
        this.onSizeChange(size);
        this.onCheckableChange(checkable);
    }
    hasChange(change) {
        return change.previousValue !== change.currentValue;
    }
    onSizeChange(size) {
        if (size && this.hasChange(size)) {
            if (!Object.values(ContactSize).includes(size.currentValue)) {
                this.size = ContactSize.Normal;
            }
        }
    }
    onCheckableChange(checkable) {
        if (checkable && this.hasChange(checkable)) {
            if (this.blocked) {
                this.checkable = false;
            }
        }
    }
    isAiAgentsMoveNotAllowed() {
        return this.isMoving && this.contact?.layout === AI_AGENT;
    }
    tooltipWarning() {
        if (this.isMoving && this.contact?.layout === AI_AGENT) {
            return this.$translate.instant('aiAgent.aiAgentsMoveNotAllowed');
        }
        if (this.blocked) {
            return this.$translate.instant('applicationsMigration.blockedWarning');
        }
        return null;
    }
    handleContactClick(event) {
        console.log('[ContactController] handleContactClick called', {
            contact: this.contact,
            blocked: this.blocked,
            checkable: this.checkable,
            disposable: this.disposable,
            isMoving: this.isMoving,
            layout: this.contact?.layout,
        });
        const isValid = (this.blocked || this.checkable || this.disposable);
        console.log('[ContactController] isValid =', isValid, ', isMoving =', this.isMoving);
        if (!isValid && !this.isMoving) {
            console.log('[ContactController] Attempting navigation, layout =', this.contact?.layout);
            if (this.contact.layout === AI_AGENT) {
                console.log('[ContactController] Going to aiAgents.home');
                this.$state.go('auth.application.detail.aiAgents.home', { shortName: this.contact.shortName }).then(() => {
                    console.log('[ContactController] Navigation to aiAgents.home successful');
                }).catch((err) => {
                    console.error('[ContactController] Navigation error:', err);
                });
                return;
            }
            console.log('[ContactController] Going to detail.home');
            this.$state.go('auth.application.detail.home', { shortName: this.contact.shortName }).then(() => {
                console.log('[ContactController] Navigation to detail.home successful');
            }).catch((err) => {
                console.error('[ContactController] Navigation error:', err);
            });
            return;
        }
        console.log('[ContactController] Click blocked by conditions');
        if (isValid) {
            event.stopPropagation();
            event.preventDefault();
            if (this.isMoving && this.contact.layout === AI_AGENT) {
                return;
            }
            if (this.checkable) {
                this.toogleChecked(event);
            }
            if (this.disposable && this.checkIfClickWasAtCloseIcon(event)) {
                this.dispose();
            }
        }
    }
    isCloseIcon(element) {
        return (element.localName === 'bds-icon' &&
            element.className.includes('close-icon'));
    }
    checkIfClickWasAtCloseIcon(event) {
        let iconEl = event.target;
        if (this.isCloseIcon(iconEl)) {
            return true;
        }
        else {
            iconEl = iconEl.parentNode;
            if (this.isCloseIcon(iconEl)) {
                return true;
            }
            else {
                iconEl = iconEl.parentNode;
                if (this.isCloseIcon(iconEl)) {
                    return true;
                }
            }
        }
        return false;
    }
    dispose() {
        if (this.onDispose) {
            this.onDispose(this.contact);
        }
    }
    async toogleChecked(event) {
        this.contact.checked = !this.contact.checked;
        if (this.onToogle) {
            this.onToogle(this.contact);
        }
    }
    async leaveChatbot(event) {
        event.stopPropagation();
        event.preventDefault();
        const yes = await this.$translate('modules.application.detail.leaveBot.yes');
        const no = await this.$translate('modules.application.detail.leaveBot.no');
        const text = await this.$translate('modules.application.detail.leaveBot.title');
        const body = await this.$translate('modules.application.detail.leaveBot.body');
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text,
            },
            body,
            buttons: {
                confirm: {
                    text: yes,
                },
                cancel: {
                    text: no,
                },
            },
        }));
        const confirmation = await modal.close;
        if (confirmation) {
            try {
                await this.ApplicationTeamService.deleteApplicationUser(this.contact.shortName, this.AuthenticationService.email);
                this.onDelete(this.contact);
                const success36 = await this.$translate('utils.successMsg.36');
                this.ngToast.success(success36);
            }
            catch (err) {
                const error = JSON.parse(err);
                if (error && error.reason && error.reason.code === 67) {
                    const permissionDenied = await this.$translate('contact.leavePermissionDenied');
                    this.BlipToastService.show('warning', {
                        msg: permissionDenied,
                    });
                    return;
                }
                console.error(err);
                const error133 = await this.$translate('utils.errorMsg.133');
                this.BlipToastService.show('danger', { msg: error133 });
            }
        }
    }
}
ContactController.$inject = ['ModalService', 'ngToast', '$translate', 'AuthenticationService', 'ApplicationTeamService', 'BlipToastService', 'APPLICATION_DEFAULT_IMAGE', '$state'];
